<div class="product-catalog">
  <div class="flex justify-content-between align-items-center mb-4">
    <h1 class="text-3xl font-bold text-primary">Catalogue produits</h1>
    <p-button 
      label="Nouveau produit" 
      icon="pi pi-plus" 
      (onClick)="openCreateDialog()">
    </p-button>
  </div>

  <!-- Filters -->
  <div class="card filters-card">
    <div class="filters-grid">
      <div class="search-container">
        <label class="filter-label">Rechercher</label>
        <span class="p-input-icon-left w-full">
          <i class="pi pi-search"></i>
          <input 
            pInputText 
            type="text" 
            [(ngModel)]="searchTerm"
            (ngModelChange)="onFiltersChanged()"
            placeholder="Produit, assureur, type..."
            class="w-full">
        </span>
      </div>

      <div>
        <label class="filter-label">Assureur</label>
        <select 
          class="w-full p-inputtext p-component" 
          [(ngModel)]="selectedInsurer"
          (ngModelChange)="onFiltersChanged()">
          <option [ngValue]="null">Tous les assureurs</option>
          <option *ngFor="let insurer of insurers" [ngValue]="insurer">{{ insurer }}</option>
        </select>
      </div>

      <div>
        <label class="filter-label">Cible</label>
        <select 
          class="w-full p-inputtext p-component" 
          [(ngModel)]="selectedTarget"
          (ngModelChange)="onFiltersChanged()">
          <option *ngFor="let option of targetOptions" [ngValue]="option.value">{{ option.label }}</option>
        </select>
      </div>

      <div>
        <label class="filter-label">Statut</label>
        <select 
          class="w-full p-inputtext p-component" 
          [(ngModel)]="selectedStatus"
          (ngModelChange)="onFiltersChanged()">
          <option value="all">Tous</option>
          <option value="active">Actifs</option>
          <option value="inactive">Inactifs</option>
        </select>
      </div>

      <div>
        <label class="filter-label">&nbsp;</label>
        <p-button 
          label="Actualiser" 
          icon="pi pi-refresh" 
          styleClass="refresh-btn w-full"
          (onClick)="loadContracts()">
        </p-button>
      </div>
    </div>
  </div>

  <!-- Products Table -->
  <div class="card">
    <p-table 
      [value]="filteredProducts"
      [loading]="loading"
      responsiveLayout="scroll">

      <ng-template pTemplate="header">
        <tr>
          <th>Logo</th>
          <th>Assureur</th>
          <th>Produit</th>
          <th>Type</th>
          <th>Statut</th>
          <th>Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-product>
        <tr>
          <td>
            <div class="logo-cell">
              <ng-container *ngIf="getInsurerLogo(product) as logo; else logoInitial">
                <img 
                  [src]="logo" 
                  [alt]="product.insurer || 'logo'" 
                  class="insurer-logo" />
              </ng-container>
              <ng-template #logoInitial>
                <span class="logo-placeholder">{{ product.insurer?.charAt(0) }}</span>
              </ng-template>
            </div>
          </td>
          <td>{{ product.insurer }}</td>
          <td>{{ product.contract_name }}</td>
          <td>{{ product.contract_type }}</td>
          <td>
            <p-tag 
              [value]="getStatusLabel(product.active)"
              [severity]="getStatusSeverity(product.active)">
            </p-tag>
          </td>
          <td>
            <div class="flex gap-2">
              <p-button 
                icon="pi pi-pencil" 
                [text]="true" 
                styleClass="action-btn"
                severity="info"
                (onClick)="editContract(product.levels[0])"
                pTooltip="Modifier">
              </p-button>

              <p-button 
                icon="pi pi-power-off" 
                [text]="true" 
                styleClass="action-btn"
                [severity]="product.active ? 'warn' : 'success'"
                (onClick)="toggleActive(product)"
                [loading]="isTogglePending(product)"
                [disabled]="isTogglePending(product)"
                [pTooltip]="product.active ? 'Désactiver' : 'Activer'">
              </p-button>

              <p-button 
                icon="pi pi-trash" 
                [text]="true" 
                styleClass="action-btn"
                severity="danger"
                (onClick)="deleteProduct(product)"
                pTooltip="Supprimer">
              </p-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Create/Edit Product Dialog -->
  <p-dialog 
    [(visible)]="showDialog" 
    [header]="dialogMode === 'create' ? 'Créer un produit' : 'Modifier le produit'"
    [modal]="true" 
    [closable]="true"
    [style]="{width: '600px'}"
    styleClass="product-dialog">
    
    <div class="product-form">
      <div class="form-row">
        <div class="form-field">
          <label class="field-label">Assureur *</label>
          <input 
            pInputText 
            [(ngModel)]="currentContract.insurer"
            class="form-input" 
            placeholder="Apivia, Alptis...">
        </div>
        <div class="form-field">
          <label class="field-label">Type</label>
          <input 
            pInputText 
            [(ngModel)]="currentContract.contract_type"
            class="form-input" 
            placeholder="Complémentaire, Surcomplémentaire...">
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label class="field-label">Nom du contrat *</label>
          <input 
            pInputText 
            [(ngModel)]="currentContract.contract_name"
            class="form-input" 
            placeholder="Santé Pro+, Vitamin3 Pro...">
        </div>
        <div class="form-field">
          <label class="field-label">Niveau *</label>
          <input 
            pInputText 
            [(ngModel)]="currentContract.level_name"
            class="form-input" 
            placeholder="Niveau 1, Formule 3...">
        </div>
      </div>

      <div class="form-row">
        <div class="form-field full-width">
          <label class="field-label">Level ID (clé technique) *</label>
          <input 
            pInputText 
            [(ngModel)]="currentContract.level_id"
            class="form-input" 
            placeholder="ex: alptis_sante_pro_plus_lvl1">
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label class="field-label">PDF du contrat</label>
          <input 
            type="file" 
            accept="application/pdf"
            (change)="onPdfFileSelected($event)"
            class="form-input">
        </div>
        <div class="form-field">
          <label class="field-label">Niveau à extraire (ex: Niveau 1)</label>
          <input 
            pInputText 
            [(ngModel)]="extractLevelName"
            class="form-input" 
            placeholder="ex: Niveau 1">
        </div>
      </div>

      <div class="form-row">
        <div class="form-field full-width">
          <p-button 
            label="Extraire depuis le PDF" 
            icon="pi pi-magic" 
            styleClass="w-full"
            [loading]="extracting"
            (onClick)="extractFromPdf()">
          </p-button>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field full-width">
          <label class="field-label">Logo du produit</label>
          <div class="logo-upload-row">
            <input 
              #logoInput
              type="file" 
              accept="image/*"
              (change)="onLogoFileSelected($event)"
              class="hidden-file-input">
            <p-button 
              label="Ajouter un logo" 
              icon="pi pi-image" 
              styleClass="logo-upload-button"
              [loading]="logoUploading"
              (onClick)="logoInput.click()">
            </p-button>
            <span class="logo-upload-info" *ngIf="currentContract.logo">
              Logo attaché
            </span>
          </div>
        </div>
      </div>

      
    </div>

    <ng-template pTemplate="footer">
      <p-button 
        label="Annuler" 
        icon="pi pi-times" 
        [text]="true"
        (onClick)="hideDialog()">
      </p-button>
      <p-button 
        [label]="dialogMode === 'create' ? 'Créer' : 'Modifier'" 
        icon="pi pi-check"
        (onClick)="saveContract()">
      </p-button>
    </ng-template>
  </p-dialog>

  <p-toast></p-toast>
  <p-confirmDialog></p-confirmDialog>
</div>
